// extracted by mini-css-extract-plugin
module.exports = {"desktop":"min-width: 75em","tablet":"min-width: 48em","header":"Header_header__KFOkc","mobileLogoLink":"Header_mobileLogoLink__jV1d1"};